/**
 * Search folding, shared by every index and query so both sides always agree.
 *
 * Adapted from IPTVnator's `foldSearchText` (MIT, see THIRD_PARTY_NOTICES.md):
 * lower-casing is locale-independent (never `toLocaleLowerCase`, which maps
 * ASCII "I" to dotless "ı" under a Turkish locale). Unlike IPTVnator this fold
 * is accent-insensitive: TV remotes make accented input impractical, so
 * "pokemon" must find "Pokémon". Punctuation collapses to single spaces.
 */
const COMBINING_MARKS = /[̀-ͯ]/g;
const NON_PRINTABLE_ASCII = /[^ -~]/;
const SEPARATORS = /[^\p{L}\p{N}]+/gu;

export function foldText(value: string): string {
  let lowered = value.toLowerCase();
  if (NON_PRINTABLE_ASCII.test(lowered)) {
    lowered = lowered.normalize('NFD').replace(COMBINING_MARKS, '').normalize('NFC');
  }
  return lowered.replace(SEPARATORS, ' ').trim();
}

export function tokenize(folded: string): string[] {
  return folded.length === 0 ? [] : folded.split(' ');
}
